import { useQuery } from "react-query";
import { getLeasedEquipmentStatus } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

// export const useGetLeasedEquipmentStatus = () => {
//   return useQuery("LeasedEquipmentStatus", getLeasedEquipmentStatus(), {
//     refetchOnWindowFocus: false,
//   });
// };

export const useGetLeasedEquipmentStatus = () => {
  const { data, isLoading, refetch } = useQuery(
    "LeasedEquipmentStatus",
    getLeasedEquipmentStatus,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
